import { useParams, Link } from 'react-router-dom';
import { useDeployment } from '../api/hooks';
import { Card } from '../components/Card';
import { StatusPill } from '../components/StatusPill';

export default function DeploymentTrace() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useDeployment(id, { poll: true });

  if (isLoading || !data) return <p className="text-arcforge-500">載入中…</p>;
  if (error) return <p className="text-red-600">錯誤：{(error as Error).message}</p>;

  const { deployment, steps } = data;

  return (
    <div className="space-y-4">
      <Link to="/" className="text-sm text-blue-600 hover:underline">
        ← 所有產品
      </Link>
      <div className="flex items-center gap-3 flex-wrap">
        <h2 className="text-2xl font-bold text-arcforge-700">Deployment</h2>
        <code className="text-xs text-arcforge-500">{deployment.id}</code>
        <StatusPill status={deployment.status} />
      </div>
      <p className="text-sm text-arcforge-500">
        產品{' '}
        <Link
          to={`/products/${deployment.product_id}`}
          className="text-blue-600 hover:underline"
        >
          {deployment.product_id}
        </Link>{' '}
        · config v{deployment.config_version}
      </p>
      {deployment.url && (
        <a
          className="block text-blue-600 hover:underline text-sm"
          href={deployment.url}
          target="_blank"
          rel="noreferrer"
        >
          → {deployment.url}
        </a>
      )}
      {deployment.error_message && (
        <Card className="border-red-200 bg-red-50">
          <p className="text-sm font-semibold text-red-700 mb-2">錯誤訊息</p>
          <pre className="text-xs text-red-700 whitespace-pre-wrap overflow-x-auto">
            {deployment.error_message}
          </pre>
        </Card>
      )}
      <Card>
        <h3 className="text-sm font-semibold mb-3">Steps</h3>
        {steps.length === 0 ? (
          <p className="text-xs text-arcforge-500">尚無步驟紀錄</p>
        ) : (
          <ol className="space-y-3">
            {steps.map((s) => (
              <li key={s.id} className="flex items-start gap-3">
                <StatusPill status={s.status} />
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm">
                    {s.order_num}. {s.name}
                  </p>
                  {s.output && (
                    <pre className="mt-1 text-xs text-arcforge-500 whitespace-pre-wrap break-all">
                      {s.output}
                    </pre>
                  )}
                </div>
              </li>
            ))}
          </ol>
        )}
      </Card>
    </div>
  );
}
